/** @rpg/nav: navigation on Recast and Detour (spike 002; loaded in phase A1, built in phase B gate B4; card
 *  engine/docs/composer/cards/nav.md). A tiled navmesh over geometry the game passes in, stateless path queries, a
 *  rebuild-one-tile seam, dynamic shapes switched off and on and their tiles rebuilt in slices over frames (phase C, gate C5), Detour's crowd as deterministic plain data, and a debug view. */
import { init } from "recast-navigation";

export const NAV_VERSION = "0.2.0" as const;

export { navGeometry, geometryBounds, type NavShape, type NavGeometry, type NavVec3, type NavQuat } from "./geometry";
export { buildNavWorld, type NavBuildOptions, type NavWorld, type NavMeshConfig, type NavPath, type NavBuildReport, type TileXY, type NavTileJob, type NavDynamicState } from "./navmesh";
export { NavTileSlicer, type SlicerOptions, type SlicerState, type SliceReport, type SlicerStats, type SlicerFaults } from "./slicer";
export { TILE_STAGES, TILE_BATCH, type TileJob, type TileStage, type TileOutcome } from "./tilejob";
export { NavCrowd, type CrowdAgentSpec, type CrowdAgentState, type CrowdOptions, type CrowdSnapshot, type CrowdFaults, type AgentGoal } from "./crowd";

/**
 * Planted defects, beside what they break. `initNeverResolves`: `initNav` returns a promise that never settles (a
 * stalled WASM init), so a game's boot spec can prove a hung module surfaces as an error instead of a silent hang.
 * Set it before the first `initNav` call. (The crowd's own, `noReseat`, lives on each `NavCrowd`'s `faults`.)
 */
export const NAV_FAULTS = { initNeverResolves: false };

let ready: Promise<void> | null = null;

/** Load and initialise Recast's WASM once; later calls share the same promise. */
export function initNav(): Promise<void> {
  ready ??= NAV_FAULTS.initNeverResolves ? new Promise<void>(() => undefined) : init();
  return ready;
}
